export function getRandomArrayIndex(array: any) {
	const randomIndex = Math.floor(Math.random() * array.length);

	if (randomIndex !== null && randomIndex !== undefined && randomIndex > 0) {
		return randomIndex;
	}

	return 0;
}
